if($('.landing-wrapp').length){
setTimeout(function() {
  $('.landing-wrapp').addClass('animated');
}, 100)

let margin = $('header').outerHeight();
$('.top-nav-items a').on('click', function() {

  // $('.top-nav-items a.active').removeClass('active');
  // $(this).addClass('active');
  var scrollAnchor = $(this).attr('data-scroll'),
      scrollPoint = $('section[data-anchor="' + scrollAnchor + '"]').offset().top - margin;

  $('body,html').animate({
      scrollTop: scrollPoint
  }, 500);

  return false;

})


if(($('#Video_Modal') .length>0 )&& ('#Video_Modal_iframe').length>0){
    $('#Video_Modal').on('hide.bs.modal', function () {
        document.getElementById('Video_Modal_iframe').src = '';
    })

}
var $animation_elements = $('.animation-element');
var $window = $(window);
$(window).scroll(function() {

  var windscroll = $(window).scrollTop();
  if (windscroll >= 100) {
      $('.landing-wrapp section').each(function(i) {
          if ($(this).position().top <= windscroll + margin + 50) {
              $('.top-nav-items a.active').removeClass('active');
              $('.top-nav-items a').eq(i).addClass('active');
              $('.landing-wrapp section').removeClass('activeSection');
              $(this).addClass('activeSection');


          }
      });

  } else {

      $('.top-nav-items a.active').removeClass('active');
      $('.top-nav-items a:first').addClass('active');
      $('.landing-wrapp section').removeClass('activeSection');
      $('.landing-wrapp section:first').addClass('activeSection');
  }
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);

  $.each($animation_elements, function() {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = (element_top_position + element_height);

      //check to see if this current container is within viewport
      if ((element_bottom_position >= window_top_position) &&
          (element_top_position <= window_bottom_position)) {
          $element.addClass('in-view');
      } else {
          $element.removeClass('in-view');
      }
  });
}).scroll();





$window.trigger('scroll');
}